// Traduzioni per Respiro Blu
// IT = Italiano (default), EN = English, ES = Español

export const translations = {
  it: {
    // Navigazione
    nav: {
      home: "Home",
      map: "Mappa",
      weather: "Meteo",
      magazine: "Rivista",
      sos: "SOS",
      calendar: "Calendario",
      history: "Storico",
      floraFauna: "Flora e Fauna",
      places: "Luoghi",
      admin: "Admin",
      profile: "Profilo",
      logout: "Esci"
    },
    // Home
    home: {
      welcome: "Benvenuto in Respiro Blu",
      subtitle: "Insieme per salvare il mare",
      totalKg: "Kg Totali Raccolti",
      co2Saved: "CO₂ Evitata",
      collections: "Raccolte",
      volunteers: "Volontari",
      newCollection: "Nuova Raccolta",
      recentActivity: "Attività Recenti"
    },
    // Form raccolta
    collection: {
      title: "Registra Raccolta",
      photo: "Scatta o carica una foto",
      analyzePhoto: "Analizza con IA",
      analyzing: "Analisi in corso...",
      materials: "Dettaglio materiali per categoria",
      totalWeight: "Peso totale",
      location: "Posizione",
      detectLocation: "Rileva posizione",
      notes: "Note (opzionale)",
      submit: "Registra Raccolta",
      success: "Raccolta registrata con successo!",
      useEstimate: "Usa questa stima",
      estimatedWeight: "Peso stimato",
      confidence: "Affidabilità stima"
    },
    // Mappa
    map: {
      title: "Mappa Raccolte",
      filters: "Filtri",
      collections: "Raccolte",
      reports: "Segnalazioni",
      underwater: "Sub",
      places: "Luoghi",
      sos: "SOS",
      mediterranean: "Siti Mediterraneo",
      amp: "AMP",
      centers: "Centri Recupero",
      oasis: "Oasi",
      zoomTip: "Fai zoom sulla mappa per vedere meglio i singoli siti",
      takeMe: "Portami qui",
      website: "Sito web ufficiale"
    },
    // Meteo
    weather: {
      title: "Meteo Mare",
      waveHeight: "Altezza Onde",
      windSpeed: "Velocità Vento",
      temperature: "Temperatura",
      seaTemp: "Temp. Mare",
      humidity: "Umidità",
      visibility: "Visibilità",
      forecast: "Previsioni"
    },
    // SOS
    sos: {
      title: "Segnala Emergenza",
      animalInDanger: "Animale in pericolo",
      pollution: "Inquinamento",
      illegalActivity: "Attività illegale",
      other: "Altro",
      description: "Descrizione emergenza",
      sendReport: "Invia Segnalazione",
      emergency: "In caso di emergenza grave chiama il 1530 (Guardia Costiera)"
    },
    // Flora e Fauna
    floraFauna: {
      title: "Flora e Fauna",
      species: "Specie",
      habitat: "Habitat",
      status: "Stato protezione",
      categories: "Categorie",
      endangered: "In pericolo",
      protected: "Protetto",
      common: "Comune"
    },
    // Admin
    admin: {
      title: "Pannello Admin",
      users: "Utenti",
      stats: "Statistiche",
      loadSites: "Carica Siti",
      organizations: "Organizzazioni",
      events: "Eventi",
      species: "Specie"
    },
    // Comuni
    common: {
      loading: "Caricamento...",
      error: "Errore",
      save: "Salva",
      cancel: "Annulla",
      delete: "Elimina",
      edit: "Modifica",
      close: "Chiudi",
      search: "Cerca",
      filter: "Filtra",
      all: "Tutti",
      none: "Nessuno",
      yes: "Sì",
      no: "No",
      confirm: "Conferma",
      back: "Indietro",
      next: "Avanti",
      date: "Data",
      time: "Ora",
      today: "Oggi",
      total: "Totale"
    },
    // Login
    auth: {
      login: "Accedi",
      register: "Registrati",
      email: "Email",
      password: "Password",
      confirmPassword: "Conferma Password",
      forgotPassword: "Password dimenticata?",
      resetPassword: "Reimposta Password",
      sendReset: "Invia link di reset",
      noAccount: "Non hai un account?",
      hasAccount: "Hai già un account?",
      loginSuccess: "Accesso effettuato!",
      registerSuccess: "Registrazione completata!"
    }
  },
  
  en: {
    nav: {
      home: "Home",
      map: "Map",
      weather: "Weather",
      magazine: "Magazine",
      sos: "SOS",
      calendar: "Calendar",
      history: "History",
      floraFauna: "Flora & Fauna",
      places: "Places",
      admin: "Admin",
      profile: "Profile",
      logout: "Logout"
    },
    home: {
      welcome: "Welcome to Respiro Blu",
      subtitle: "Together to save the sea",
      totalKg: "Total Kg Collected",
      co2Saved: "CO₂ Avoided",
      collections: "Collections",
      volunteers: "Volunteers",
      newCollection: "New Collection",
      recentActivity: "Recent Activity"
    },
    collection: {
      title: "Register Collection",
      photo: "Take or upload a photo",
      analyzePhoto: "Analyze with AI",
      analyzing: "Analyzing...",
      materials: "Material details by category",
      totalWeight: "Total weight",
      location: "Location",
      detectLocation: "Detect location",
      notes: "Notes (optional)",
      submit: "Register Collection",
      success: "Collection registered successfully!",
      useEstimate: "Use this estimate",
      estimatedWeight: "Estimated weight",
      confidence: "Estimate reliability"
    },
    map: {
      title: "Collections Map",
      filters: "Filters",
      collections: "Collections",
      reports: "Reports",
      underwater: "Underwater",
      places: "Places",
      sos: "SOS",
      mediterranean: "Mediterranean Sites",
      amp: "MPA",
      centers: "Rescue Centers",
      oasis: "Wildlife Oasis",
      zoomTip: "Zoom in to see individual sites better",
      takeMe: "Take me there",
      website: "Official website"
    },
    weather: {
      title: "Sea Weather",
      waveHeight: "Wave Height",
      windSpeed: "Wind Speed",
      temperature: "Temperature",
      seaTemp: "Sea Temp",
      humidity: "Humidity",
      visibility: "Visibility",
      forecast: "Forecast"
    },
    sos: {
      title: "Report Emergency",
      animalInDanger: "Animal in danger",
      pollution: "Pollution",
      illegalActivity: "Illegal activity",
      other: "Other",
      description: "Emergency description",
      sendReport: "Send Report",
      emergency: "In case of serious emergency call local Coast Guard"
    },
    floraFauna: {
      title: "Flora & Fauna",
      species: "Species",
      habitat: "Habitat",
      status: "Protection status",
      categories: "Categories",
      endangered: "Endangered",
      protected: "Protected",
      common: "Common"
    },
    admin: {
      title: "Admin Panel",
      users: "Users",
      stats: "Statistics",
      loadSites: "Load Sites",
      organizations: "Organizations",
      events: "Events",
      species: "Species"
    },
    common: {
      loading: "Loading...",
      error: "Error",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      close: "Close",
      search: "Search",
      filter: "Filter",
      all: "All",
      none: "None",
      yes: "Yes",
      no: "No",
      confirm: "Confirm",
      back: "Back",
      next: "Next",
      date: "Date",
      time: "Time",
      today: "Today",
      total: "Total"
    },
    auth: {
      login: "Login",
      register: "Register",
      email: "Email",
      password: "Password",
      confirmPassword: "Confirm Password",
      forgotPassword: "Forgot password?",
      resetPassword: "Reset Password",
      sendReset: "Send reset link",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      loginSuccess: "Login successful!",
      registerSuccess: "Registration complete!"
    }
  },
  
  es: {
    nav: {
      home: "Inicio",
      map: "Mapa",
      weather: "Clima",
      magazine: "Revista",
      sos: "SOS",
      calendar: "Calendario",
      history: "Historial",
      floraFauna: "Flora y Fauna",
      places: "Lugares",
      admin: "Admin",
      profile: "Perfil",
      logout: "Salir"
    },
    home: {
      welcome: "Bienvenido a Respiro Blu",
      subtitle: "Juntos para salvar el mar",
      totalKg: "Kg Totales Recogidos",
      co2Saved: "CO₂ Evitado",
      collections: "Recolecciones",
      volunteers: "Voluntarios",
      newCollection: "Nueva Recolección",
      recentActivity: "Actividad Reciente"
    },
    collection: {
      title: "Registrar Recolección",
      photo: "Tomar o subir una foto",
      analyzePhoto: "Analizar con IA",
      analyzing: "Analizando...",
      materials: "Detalle de materiales por categoría",
      totalWeight: "Peso total",
      location: "Ubicación",
      detectLocation: "Detectar ubicación",
      notes: "Notas (opcional)",
      submit: "Registrar Recolección",
      success: "¡Recolección registrada con éxito!",
      useEstimate: "Usar esta estimación",
      estimatedWeight: "Peso estimado",
      confidence: "Fiabilidad de la estimación"
    },
    map: {
      title: "Mapa de Recolecciones",
      filters: "Filtros",
      collections: "Recolecciones",
      reports: "Reportes",
      underwater: "Submarino",
      places: "Lugares",
      sos: "SOS",
      mediterranean: "Sitios Mediterráneo",
      amp: "AMP",
      centers: "Centros de Rescate",
      oasis: "Oasis de Fauna",
      zoomTip: "Haz zoom para ver mejor los sitios individuales",
      takeMe: "Llévame allí",
      website: "Sitio web oficial"
    },
    weather: {
      title: "Clima Marino",
      waveHeight: "Altura de Olas",
      windSpeed: "Velocidad del Viento",
      temperature: "Temperatura",
      seaTemp: "Temp. del Mar",
      humidity: "Humedad",
      visibility: "Visibilidad",
      forecast: "Pronóstico"
    },
    sos: {
      title: "Reportar Emergencia",
      animalInDanger: "Animal en peligro",
      pollution: "Contaminación",
      illegalActivity: "Actividad ilegal",
      other: "Otro",
      description: "Descripción de la emergencia",
      sendReport: "Enviar Reporte",
      emergency: "En caso de emergencia grave llama a la Guardia Costera local"
    },
    floraFauna: {
      title: "Flora y Fauna",
      species: "Especies",
      habitat: "Hábitat",
      status: "Estado de protección",
      categories: "Categorías",
      endangered: "En peligro",
      protected: "Protegido",
      common: "Común"
    },
    admin: {
      title: "Panel de Admin",
      users: "Usuarios",
      stats: "Estadísticas",
      loadSites: "Cargar Sitios",
      organizations: "Organizaciones",
      events: "Eventos",
      species: "Especies"
    },
    common: {
      loading: "Cargando...",
      error: "Error",
      save: "Guardar",
      cancel: "Cancelar",
      delete: "Eliminar",
      edit: "Editar",
      close: "Cerrar",
      search: "Buscar",
      filter: "Filtrar",
      all: "Todos",
      none: "Ninguno",
      yes: "Sí",
      no: "No",
      confirm: "Confirmar",
      back: "Atrás",
      next: "Siguiente",
      date: "Fecha",
      time: "Hora",
      today: "Hoy",
      total: "Total"
    },
    auth: {
      login: "Iniciar Sesión",
      register: "Registrarse",
      email: "Correo",
      password: "Contraseña",
      confirmPassword: "Confirmar Contraseña",
      forgotPassword: "¿Olvidaste tu contraseña?",
      resetPassword: "Restablecer Contraseña",
      sendReset: "Enviar enlace de restablecimiento",
      noAccount: "¿No tienes cuenta?",
      hasAccount: "¿Ya tienes cuenta?",
      loginSuccess: "¡Inicio de sesión exitoso!",
      registerSuccess: "¡Registro completado!"
    }
  },

  hr: {
    nav: {
      home: "Početna",
      map: "Karta",
      weather: "Vrijeme",
      magazine: "Časopis",
      sos: "SOS",
      calendar: "Kalendar",
      history: "Povijest",
      floraFauna: "Flora i Fauna",
      places: "Mjesta",
      admin: "Admin",
      profile: "Profil",
      logout: "Odjava"
    },
    home: {
      welcome: "Dobrodošli u Respiro Blu",
      subtitle: "Zajedno za spas mora",
      totalKg: "Ukupno prikupljeno kg",
      co2Saved: "Izbjegnuti CO₂",
      collections: "Prikupljanja",
      volunteers: "Volonteri",
      newCollection: "Novo prikupljanje",
      recentActivity: "Nedavne aktivnosti"
    },
    collection: {
      title: "Registriraj prikupljanje",
      photo: "Snimi ili učitaj fotografiju",
      analyzePhoto: "Analiziraj s AI",
      analyzing: "Analiziranje...",
      materials: "Detalji materijala po kategoriji",
      totalWeight: "Ukupna težina",
      location: "Lokacija",
      detectLocation: "Otkrij lokaciju",
      notes: "Bilješke (neobavezno)",
      submit: "Registriraj prikupljanje",
      success: "Prikupljanje uspješno registrirano!",
      useEstimate: "Koristi ovu procjenu",
      estimatedWeight: "Procijenjena težina",
      confidence: "Pouzdanost procjene"
    },
    map: {
      title: "Karta prikupljanja",
      filters: "Filteri",
      collections: "Prikupljanja",
      reports: "Prijave",
      underwater: "Podvodno",
      places: "Mjesta",
      sos: "SOS",
      mediterranean: "Mediteranska mjesta",
      amp: "ZMP",
      centers: "Centri za spašavanje",
      oasis: "Oaze divljih životinja",
      zoomTip: "Zumirajte za bolji prikaz pojedinih lokacija",
      takeMe: "Odvedi me tamo",
      website: "Službena web stranica"
    },
    weather: {
      title: "Morsko vrijeme",
      waveHeight: "Visina valova",
      windSpeed: "Brzina vjetra",
      temperature: "Temperatura",
      seaTemp: "Temp. mora",
      humidity: "Vlažnost",
      visibility: "Vidljivost",
      forecast: "Prognoza"
    },
    sos: {
      title: "Prijavi hitni slučaj",
      animalInDanger: "Životinja u opasnosti",
      pollution: "Onečišćenje",
      illegalActivity: "Ilegalna aktivnost",
      other: "Ostalo",
      description: "Opis hitnog slučaja",
      sendReport: "Pošalji prijavu",
      emergency: "U slučaju ozbiljne hitnosti nazovite lokalnu Obalnu stražu"
    },
    floraFauna: {
      title: "Flora i Fauna",
      species: "Vrste",
      habitat: "Stanište",
      status: "Status zaštite",
      categories: "Kategorije",
      endangered: "Ugroženo",
      protected: "Zaštićeno",
      common: "Uobičajeno"
    },
    admin: {
      title: "Admin panel",
      users: "Korisnici",
      stats: "Statistika",
      loadSites: "Učitaj lokacije",
      organizations: "Organizacije",
      events: "Događaji",
      species: "Vrste"
    },
    common: {
      loading: "Učitavanje...",
      error: "Greška",
      save: "Spremi",
      cancel: "Odustani",
      delete: "Izbriši",
      edit: "Uredi",
      close: "Zatvori",
      search: "Traži",
      filter: "Filtriraj",
      all: "Sve",
      none: "Ništa",
      yes: "Da",
      no: "Ne",
      confirm: "Potvrdi",
      back: "Natrag",
      next: "Dalje",
      date: "Datum",
      time: "Vrijeme",
      today: "Danas",
      total: "Ukupno"
    },
    auth: {
      login: "Prijava",
      register: "Registracija",
      email: "Email",
      password: "Lozinka",
      confirmPassword: "Potvrdi lozinku",
      forgotPassword: "Zaboravljena lozinka?",
      resetPassword: "Resetiraj lozinku",
      sendReset: "Pošalji link za resetiranje",
      noAccount: "Nemate račun?",
      hasAccount: "Već imate račun?",
      loginSuccess: "Prijava uspješna!",
      registerSuccess: "Registracija završena!"
    }
  }
};

export default translations;
